export enum Device {
  MOBILE = 'mobile',
  DESKTOP = 'desktop',
}
